import React, { useEffect, useState } from "react";
import { Button, Input } from "reactstrap";
import {
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    BankOutlined,
    CalendarOutlined,
    SafetyOutlined,
    CrownOutlined,
    LineChartOutlined,
    CreditCardOutlined,
    FileTextOutlined,
    UploadOutlined,
    ClockCircleOutlined,
    SyncOutlined,
    CheckCircleOutlined,
    SettingOutlined,
} from "@ant-design/icons";
import {
    capitalizeFirstLetter,
    formatDateTime,
} from "../../../../utils/functions";
import SOURCES from "../../../../utils/constants";
import usePost from "../../../../services/usePost";
import { Col, Row, Select, Tag } from "antd";
import CommonCard from "../../../global/card";
import { cn } from "../../../../utils/cn";
import CommonDatePicker from "../../../global/datePicker";
import CommonDialog from "../../../global/dialog";

const EnhanceUserDetails = ({
    leadDetail,
    userInfo,
    setUserInfo,
    paymentPlans,
    loginAsUser,
    deleteUser,
    removeSuccess,
    getUsers,
    setshowDeatail,
    getBadgeColor,
}) => {
    const [loading, setLoading] = useState(false);
    const [trialPeriod, setTrialPeriod] = useState("");
    const [activateTill, setActivateTill] = useState("");
    const [userSettings, setUserSettings] = useState({
        settingKey: "MAX_LEADS_UPLOAD_VIA_CSV",
        settingValue: "",
    });

    const [toggleModalOptions, setToggleModalOptions] = useState({
        showModal: false,
        title: "",
        postMessage: "",
        actionMethod: "",
        type: "",
    });

    console.log("leadDetail", leadDetail);

    const { callApi: changeUserPaymentPlan, processSuccess: paymentPlanSuccess } =
        usePost({
            endpoint: `admin/change-user-plan`,
        });

    const { callApi: changeUserTrialPeriod, processSuccess: trialPeriodSuccess } =
        usePost({
            endpoint: `admin/change-user-trial-period`,
        });

    const { callApi: changeVerificationCode, processSuccess: resendSuccess } =
        usePost({
            endpoint: `admin/resent-verification-code`,
        });

    const { callApi: updateUserSettings, processSuccess: maxLeadsUploadSuccess } =
        usePost({
            endpoint: `user/settings`,
        });

    const {
        callApi: reactivateAccount,
        processSuccess: reavtivateAcountSuccess,
    } = usePost({
        endpoint: `admin/reactivate-account`,
    });

    useEffect(() => {
        if (
            resendSuccess ||
            paymentPlanSuccess ||
            trialPeriodSuccess ||
            maxLeadsUploadSuccess ||
            reavtivateAcountSuccess
        )
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    }, [
        resendSuccess,
        paymentPlanSuccess,
        trialPeriodSuccess,
        maxLeadsUploadSuccess,
        reavtivateAcountSuccess,
    ]);

    const setSettings = () => {
        if (leadDetail?.UserSettings?.length > 0) {
            leadDetail?.UserSettings?.map((setting) => {
                setUserSettings((prevState) => ({
                    ...prevState,
                    settingValue: setting.settingValue,
                }));
            });
        } else {
            setUserSettings((prevState) => ({
                ...prevState,
                settingValue: "",
            }));
        }
    };

    useEffect(() => {
        setSettings();
    }, [leadDetail]);

    useEffect(() => {
        if (removeSuccess) {
            setToggleModalOptions({
                ...toggleModalOptions,
                showModal: false,
            });
            setshowDeatail(false);
            getUsers();
        }
    }, [removeSuccess]);

    const resendVerificationCode = async () => {
        const res = await changeVerificationCode({ email: leadDetail.email });
        if (res.status !== SOURCES.HTTP_CODE_200)
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    };

    const changeUserPayment = async () => {
        const res = await changeUserPaymentPlan(
            {
                email: leadDetail.email,
                paymentPlanId: userInfo.plan,
            },
            "Payment plan changed successfully",
            true
        );

        if (res.status !== SOURCES.HTTP_CODE_200)
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    };

    const changeUserTrial = async () => {
        const res = await changeUserTrialPeriod(
            {
                email: leadDetail.email,
                trialPeriod,
            },
            "Trial period changed successfully",
            true
        );

        if (res.status !== SOURCES.HTTP_CODE_200)
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    };

    const saveUserSettings = async () => {
        const res = await updateUserSettings(
            {
                userId: leadDetail._id,
                settings: [userSettings],
            },
            "Settings updated successfully",
            true
        );

        if (res.status !== SOURCES.HTTP_CODE_200)
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    };

    const saveReactivateAccount = async () => {
        const res = await reactivateAccount(
            {
                email: leadDetail.email,
                reactivatedTillDate: activateTill,
            },
            "Account reactivated successfully",
            true
        );

        if (res.status !== SOURCES.HTTP_CODE_200)
            setToggleModalOptions({ ...toggleModalOptions, showModal: false });
    };

    if (!leadDetail) return null;

    const getIconForField = (label) => {
        const iconMap = {
            Name: <UserOutlined />,
            Email: <MailOutlined />,
            Phone: <PhoneOutlined />,
            Company: <BankOutlined />,
            "Registered On": <CalendarOutlined />,
            Verified: <SafetyOutlined />,
            Role: <CrownOutlined />,
            Status: <LineChartOutlined />,
            "Trial Period": <ClockCircleOutlined />,
            "Trial Ended At": <CalendarOutlined />,
            "Payment Status": <CreditCardOutlined />,
            "Current Plan": <FileTextOutlined />,
            "CSV Leads Upload Limit": <UploadOutlined />,
        };
        return iconMap[label] || <FileTextOutlined />;
    };

    const SectionHeader = ({ icon, title }) => (
        <div className="flex items-center gap-2 mb-3 sm:mb-4">
            {React.cloneElement(icon, { style: { color: "var(--primary-color, #1890ff)", fontSize: "clamp(14px, 4vw, 16px)" } })}
            <span style={{ fontSize: "clamp(13px, 4vw, 15px)", fontWeight: 600 }}>{title}</span>
        </div>
    );

    const InfoItem = ({ label, value, isTag, color, className }) => (
        <Col xs={24} sm={12}>
            <div className="flex flex-col">
                <span className="text-xs text-gray-500 flex items-center gap-2 mb-1">
                    <span style={{ color: "var(--primary-color, #1890ff)" }}>
                        {getIconForField(label)}
                    </span>
                    {label}
                </span>
                {isTag ? (
                    <Tag color={getBadgeColor({ color })} className={cn("m-0 px-3 py-1 font-medium capitalize w-fit", className)}>
                        {value || "—"}
                    </Tag>
                ) : (
                    <span className={cn("text-sm font-semibold text-gray-900", className)}>{value || "—"}</span>
                )}
            </div>
        </Col>
    );

    return (
        <div className="sm:!p-6 p-2 w-full min-h-full overflow-x-hidden" style={{ backgroundColor: "#f5f7fa" }}>
            <div className="flex flex-col gap-6">
                <Row gutter={[24, 24]}>
                    <Col xs={24} lg={12}>
                        <CommonCard
                            cardHeadBodyClassName={{ head: "!px-6 !py-0", body: "!px-6 !py-0 !pb-4" }}
                            title={
                                <div className="flex items-center gap-2">
                                    <UserOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "clamp(16px, 5vw, 18px)" }} />
                                    <span style={{ fontSize: "clamp(14px, 5vw, 16px)", fontWeight: 600 }}>Basic Details</span>
                                </div>
                            }
                        >
                            <Row gutter={[{ xs: 16, sm: 24 }, { xs: 12, sm: 16 }]} className="py-4">
                                <InfoItem label="Name" value={leadDetail?.name} />
                                <InfoItem label="Email" value={leadDetail?.email} />
                                <InfoItem label="Phone" value={leadDetail?.phone} />
                                <InfoItem label="Company" value={leadDetail?.company} />
                                <InfoItem label="Registered On" value={formatDateTime(leadDetail?.createdAt)} />
                            </Row>
                        </CommonCard>
                    </Col>

                    <Col xs={24} lg={12}>
                        <CommonCard
                            cardHeadBodyClassName={{ head: "!px-6 !py-0", body: "!px-6 !py-0 !pb-4" }}
                            title={
                                <div className="flex items-center gap-2">
                                    <SafetyOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "clamp(16px, 5vw, 18px)" }} />
                                    <span style={{ fontSize: "clamp(14px, 5vw, 16px)", fontWeight: 600 }}>Verification Details</span>
                                </div>
                            }
                        >
                            <div className="py-4">
                                <Row gutter={[{ xs: 16, sm: 24 }, { xs: 12, sm: 16 }]}>
                                    <InfoItem
                                        label="Verified"
                                        value={leadDetail?.verified === "Verified" ? "Yes" : "No"}
                                        isTag
                                        color={leadDetail?.verifiedBadge?.color}
                                    />
                                    <InfoItem
                                        label="Role"
                                        value={leadDetail?.userRole}
                                        isTag
                                        color="primary"
                                    />
                                    <InfoItem
                                        label="Status"
                                        value={leadDetail?.statusBadge.text}
                                        isTag
                                        color={leadDetail?.statusBadge.color}
                                    />
                                </Row>
                                <Button
                                    className={cn(
                                        "mt-6 w-full flex items-center justify-center gap-x-2 border transition-all duration-200 !h-10 sm:!h-11 font-medium",
                                        leadDetail?.verified !== "Not Verified"
                                            ? "bg-gray-100 text-gray-400 border-gray-200"
                                            : "!border-primary text-primary bg-transparent hover:!bg-primary hover:!text-white"
                                    )}
                                    disabled={leadDetail?.verified !== "Not Verified"}
                                    onClick={() => {
                                        setToggleModalOptions({
                                            ...toggleModalOptions,
                                            showModal: true,
                                            title: "Resend Verification Code",
                                            postMessage: "Are you sure you want to Resend Verification Code?",
                                            actionMethod: () => resendVerificationCode(),
                                            type: "RESEND_VERIFICATION_CODE",
                                        });
                                    }}
                                >
                                    <SyncOutlined style={{ fontSize: "16px" }} />
                                    Resend Verification Code
                                </Button>
                            </div>
                        </CommonCard>
                    </Col>
                </Row>

                {leadDetail?.userRole !== SOURCES.USER_ROLE_ADMIN && (
                    <Row gutter={[24, 24]}>
                        <Col xs={24} lg={12}>
                            <CommonCard
                                cardHeadBodyClassName={{ head: "!px-6 !py-0", body: "!px-6 !py-0 !pb-4" }}
                                title={
                                    <div className="flex items-center gap-2">
                                        <ClockCircleOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "clamp(16px, 5vw, 18px)" }} />
                                        <span style={{ fontSize: "clamp(14px, 5vw, 16px)", fontWeight: 600 }}>Trial Period</span>
                                    </div>
                                }
                            >
                                <div className="py-4">
                                    <Row gutter={[{ xs: 16, sm: 24 }, { xs: 12, sm: 16 }]}>
                                        <InfoItem
                                            label="Trial Period"
                                            value={leadDetail?.isTrial === "y" ? "Yes" : "No"}
                                            isTag
                                            color={leadDetail?.trialBadge.color}
                                        />
                                        <InfoItem
                                            label="Trial Ended At"
                                            value={(leadDetail?.userStatus === SOURCES.USER_STATUS_TRIAL_END || leadDetail?.userStatus === SOURCES.USER_STATUS_TRIAL) && formatDateTime(leadDetail?.updatedAt, "MMM Do YY")}
                                        />
                                        <Col span={24}>
                                            <div className="flex flex-col">
                                                <span className="text-xs text-gray-500 flex items-center gap-2 mb-2">
                                                    <span style={{ color: "var(--primary-color, #1890ff)" }}><CalendarOutlined /></span>
                                                    Change Trial Period
                                                </span>
                                                <CommonDatePicker
                                                    onChange={(date) => setTrialPeriod(date)}
                                                    value={trialPeriod}
                                                    className="!h-10 sm:!h-11 w-full"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Button
                                        className="mt-6 w-full flex items-center justify-center gap-x-2 border !border-primary text-primary bg-transparent hover:!bg-primary hover:!text-white transition-all duration-200 !h-10 sm:!h-11 font-medium"
                                        onClick={() => {
                                            setToggleModalOptions({
                                                ...toggleModalOptions,
                                                showModal: true,
                                                title: "Update Trial Period",
                                                postMessage: "Are you sure you want to Update Trial Period?",
                                                actionMethod: () => changeUserTrial(),
                                                type: "UPDATE_TRIAL_PERIOD",
                                            });
                                        }}
                                    >
                                        <CheckCircleOutlined style={{ fontSize: "16px" }} />
                                        Update Trial Period
                                    </Button>
                                </div>
                            </CommonCard>
                        </Col>

                        <Col xs={24} lg={12}>
                            <CommonCard
                                cardHeadBodyClassName={{ head: "!px-6 !py-0", body: "!px-6 !py-0 !pb-4" }}
                                title={
                                    <div className="flex items-center gap-2">
                                        <CreditCardOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "clamp(16px, 5vw, 18px)" }} />
                                        <span style={{ fontSize: "clamp(14px, 5vw, 16px)", fontWeight: 600 }}>Payment Details</span>
                                    </div>
                                }
                            >
                                <div className="py-4">
                                    <Row gutter={[{ xs: 16, sm: 24 }, { xs: 12, sm: 16 }]}>
                                        <InfoItem
                                            label="Payment Status"
                                            value={leadDetail?.paymentStatus ? "Paid" : "Not Paid"}
                                            isTag
                                            color={leadDetail?.paymentStatus ? "success" : "danger"}
                                        />
                                        <InfoItem
                                            label="Current Plan"
                                            value={leadDetail?.PlanInformation?.planName || leadDetail?.PlanInformation[0]?.planName}
                                            isTag
                                            color="primary"
                                        />
                                        <Col span={24}>
                                            <div className="flex flex-col">
                                                <span className="text-xs text-gray-500 flex items-center gap-2 mb-2">
                                                    <span style={{ color: "var(--primary-color, #1890ff)" }}><FileTextOutlined /></span>
                                                    Change Plan
                                                </span>
                                                <Select
                                                    options={SOURCES.getPaymentPlans(paymentPlans)}
                                                    value={userInfo?.plan}
                                                    onChange={(value) => setUserInfo({ ...userInfo, plan: value })}
                                                    placeholder="Select Plan"
                                                    className="!h-10 sm:!h-11 w-full"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Button
                                        className="mt-6 w-full flex items-center justify-center gap-x-2 border !border-primary text-primary bg-transparent hover:!bg-primary hover:!text-white transition-all duration-200 !h-10 sm:!h-11 font-medium"
                                        onClick={() => {
                                            setToggleModalOptions({
                                                ...toggleModalOptions,
                                                showModal: true,
                                                title: "Update Payment Plan",
                                                postMessage: "Are you sure you want to Update Payment Plan?",
                                                actionMethod: () => changeUserPayment(),
                                                type: "UPDATE_PAYMENT_PLAN",
                                            });
                                        }}
                                    >
                                        <CheckCircleOutlined style={{ fontSize: "16px" }} />
                                        Update Payment Plan
                                    </Button>
                                </div>
                            </CommonCard>
                        </Col>

                        <Col xs={24}>
                            <CommonCard
                                cardHeadBodyClassName={{ head: "!px-6 !py-0", body: "!px-6 !py-0 !pb-4" }}
                                title={
                                    <div className="flex items-center gap-2">
                                        <SettingOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "clamp(16px, 5vw, 18px)" }} />
                                        <span style={{ fontSize: "clamp(14px, 5vw, 16px)", fontWeight: 600 }}>Settings</span>
                                    </div>
                                }
                            >
                                <div className="py-4">
                                    <Row gutter={[{ xs: 16, sm: 24 }, { xs: 12, sm: 16 }]}>
                                        <Col span={24}>
                                            <div className="flex flex-col gap-2">
                                                <span className="text-xs text-gray-500 flex items-center gap-2">
                                                    <span style={{ color: "var(--primary-color, #1890ff)" }}><UploadOutlined /></span>
                                                    CSV Leads Upload Limit
                                                </span>
                                                <div className="flex flex-col sm:flex-row gap-4">
                                                    <Input
                                                        placeholder="Enter CSV Leads Upload Limit"
                                                        type="number"
                                                        value={userSettings?.settingValue}
                                                        onChange={(e) => setUserSettings({ ...userSettings, settingValue: e.target.value })}
                                                        className="h-10 sm:!h-11 !w-full sm:!w-2/3 border border-gray-200 focus:border-primary transition-all"
                                                    />
                                                    <Button
                                                        className="!w-full sm:!w-1/3 flex items-center justify-center gap-x-2 border !border-primary text-primary bg-transparent hover:!bg-primary hover:!text-white transition-all duration-200 !h-10 sm:!h-11 font-medium"
                                                        onClick={() => {
                                                            setToggleModalOptions({
                                                                ...toggleModalOptions,
                                                                showModal: true,
                                                                title: "Update Settings",
                                                                postMessage: "Are you sure you want to Update Settings?",
                                                                actionMethod: () => saveUserSettings(),
                                                                type: "UPDATE_SETTINGS",
                                                            });
                                                        }}
                                                    >
                                                        <CheckCircleOutlined style={{ fontSize: "16px" }} />
                                                        Update Settings
                                                    </Button>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </CommonCard>
                        </Col>
                    </Row>
                )}
            </div>
            {toggleModalOptions?.showModal && (
                <CommonDialog
                    title={toggleModalOptions?.title}
                    description={toggleModalOptions?.postMessage}
                    onOk={async () => {
                        setLoading(true);
                        await toggleModalOptions?.actionMethod();
                        setLoading(false);
                        if (toggleModalOptions?.type !== "RESEND_VERIFICATION_CODE") {
                            getUsers();
                        }
                        setToggleModalOptions({ ...toggleModalOptions, showModal: false });
                    }}
                    onCancel={() =>
                        setToggleModalOptions({ ...toggleModalOptions, showModal: false })
                    }
                    open={toggleModalOptions?.showModal}
                    setOpen={() =>
                        setToggleModalOptions({ ...toggleModalOptions, showModal: false })
                    }
                    isConfirmButtonLoading={loading}
                />
            )}
        </div>
    );
};

export default EnhanceUserDetails;
